export default "__VITE_ASSET__BnpGYl8P__"